import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.updatePersonalization);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.updatePersonalization);
  }

  updatePersonalization = (event) => {
    const wrapper = this.querySelector('[data-hh-personalization]');
    if (!wrapper || String(event.detail?.data?.productId) !== wrapper.dataset.productId) return;
    const section = this.closest('.shopify-section');
    if (section && !section.contains(event.target)) return;
    const updated = event.detail?.data?.html?.getElementById(wrapper.id);
    if (!updated) return;
    wrapper.hidden = updated.hidden;
    for (const group of wrapper.querySelectorAll('[data-hh-conditional-field]')) {
      const source = updated.querySelector('#' + CSS.escape(group.id));
      if (source) group.hidden = source.hidden;
    }
    for (const input of wrapper.querySelectorAll('input, textarea')) {
      const source = updated.querySelector('#' + CSS.escape(input.id));
      if (!source) continue;
      input.required = source.required;
      input.disabled = source.disabled;
      input.setAttribute('aria-required', String(source.required));
      if (input.disabled) input.setCustomValidity('');
    }
  };

  handleInput() {
    const { characterCount, textInput } = this.refs;
    if (!characterCount || !textInput) return;
    const template = characterCount.getAttribute('data-template');
    if (!template) return;
    characterCount.textContent = template
      .replace('[current]', textInput.value.length.toString())
      .replace('[max]', textInput.maxLength.toString());
  }
}

if (!customElements.get('product-custom-property-component')) {
  customElements.define('product-custom-property-component', ProductCustomProperty);
}


